<div class="modal-header">
    <h2 class="modal-title">Email ACH Authorization Form</h2>
</div>
<div class="modal-body row" (keyup.esc)="cancel()">
    <div class="col-12">
        <dx-form *ngIf="model" [formData]="model" validationGroup="achEmailValidationGroup">
            <dxi-item dataField="to">
                <dxi-validation-rule type="required"></dxi-validation-rule>
                <dxi-validation-rule type="custom" message="Invalid email" [validationCallback]="validateEmail" [reevaluate]="true"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="cc">
                <dxi-validation-rule type="custom" message="Invalid email" [validationCallback]="validateEmail" [reevaluate]="true"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="subject" [isRequired]="true"></dxi-item>
            <dxi-item dataField="body" editorType="dxTextArea" [editorOptions]="{ height: 300 }" [isRequired]="true"></dxi-item>
        </dx-form>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" [disabled]="processing" (click)="send()">Save</button>
    <button type="button" class="btn btn-secondary" [disabled]="processing" (click)="cancel()">Cancel</button>
</div>
